import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { sortItems } from '@ego/domain';
import styles from './ProfileTableView.module.css';

export default function ProfileTableView({ channels = [], order = 'newest' }) {
  const sorted = useMemo(
    () => sortItems(channels, order),
    [channels, order]
  );

  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.thTitle}>Title</th>
            <th className={styles.thBlocks}>Blocks</th>
            <th className={styles.thUpdated}>Modified</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((channel) => (
            <tr key={channel.id} className={styles.row}>
              <td className={styles.tdTitle}>
                <Link
                  to={channel.handle ? `/${channel.handle}/${channel.slug}` : `/channels/${channel.slug}`}
                  className={styles.titleLink}
                  style={channel.accentColor ? { color: channel.accentColor } : undefined}
                >
                  {channel.title}
                </Link>
              </td>
              <td className={styles.tdBlocks}>{channel.blocksCount}</td>
              <td className={styles.tdUpdated}>{channel.updatedRelative}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
